export type TimeRetailPricePerHourType = "none" | "flat_based" | "role_based"



export const TimeRetailPricePerHour = {
    flatBased: "flat_based",
    roleBased: "role_based"
} as const;